import React from "react";
import TwoFactorEnrollForm from "../TwoFactorEnrollForm";

const TwoFactorEnroll = () => {
  return (
    <div className="min-h-svh w-full flex items-center justify-center bg-muted text-foreground p-6">
      <TwoFactorEnrollForm />
    </div>
  );
};

export default TwoFactorEnroll;
